import {takeLatest, put} from 'redux-saga/effects';
import {
  UPLOAD_DATA_SERVICES,
  UPLOAD_DATA_SERVICES_SUCCESS,
  UPLOAD_DATA_SERVICES_FAILED,
} from './constants';

import {UploadDataServicesRetrieveRequestBuilder} from 'client-sdk/src/data-services/data-services';

import Client from 'client-sdk/src/client';
import handleError from '../../utils/handleError';
import handleNotfication from '../../utils/handleNotfication';

export function* uploadDataServices(actions: any) {
  try {
    const makeOrdersRequest = new UploadDataServicesRetrieveRequestBuilder()
      .data(actions.payload)
      .build();

    const client = new Client('', 'multipart/form-data');
    yield client.execute(makeOrdersRequest);
    yield put({
      type: UPLOAD_DATA_SERVICES_SUCCESS,
    });
    handleNotfication('بارگذاری با موفقیت انجام شد ', 'success');
  } catch (error) {
    yield put({
      type: UPLOAD_DATA_SERVICES_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export default function* uploadInfoSaga() {
  yield takeLatest(UPLOAD_DATA_SERVICES, uploadDataServices);
}
